import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { AssetsapiService } from './assetsapi.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { Editor, NgxEditorComponent, NgxEditorMenuComponent, Toolbar } from 'ngx-editor';
import { MatDialog } from '@angular/material/dialog';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { Email_Configuration_Service } from '../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { BalanceSheetapiService } from '../balancesheet/balance-sheetapi.service';
import { CharitiesService } from '../charities/services/charities.service';
import Swal from 'sweetalert2';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { ReportsService } from '../reports/reports.service';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { SubmissionsapiService } from '../submissions/submissionsapi.service';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';

@Component({
  selector: 'app-statementofassets',
  imports: [CommonModule, MaterialModule, RouterModule, TablerIconsModule, CommonModule, FormsModule, ReactiveFormsModule, MatRadioModule, NgxEditorComponent, NgxEditorMenuComponent, PdfJsViewerModule],
  templateUrl: './statementofassets.component.html',
  styleUrl: './statementofassets.component.scss'
})
export class StatementofassetsComponent implements OnInit {
  pdfFile: string;
  Downloadreportname: string;
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
  fundTrackingEnabled: boolean = false;
  ShowSpinner: any = false;
    BasicInformation: any;
  apFinalised: boolean = false;
  exportForm: FormGroup
    CharityDetails: CharityDetailsModal[];
    Base64orHTML: any;
    CurrentUserName: string;
  base64String: any;
  SubmissionStatus: any;


  constructor(private Submissionsapiservice: SubmissionsapiService,private router: Router, private sharedService: CharityDataShareServiceService, private reportservice: ReportsService, private _UsermanagementService: UsermanagementService, private fb: FormBuilder, private apiservicemail: BalanceSheetapiService, private apiservice: AssetsapiService, public dialog: MatDialog, private emailConfigService: Email_Configuration_Service, public Charities_Service: CharitiesService, private datashare: NotesDatashareService, private msgService: MessageServiceService,) {
    this.GetUserAccess()
    this.fundTrackingEnabled = localStorage.getItem('fund_Tracking') === 'true';
//    this.Getbasicinformation()
    this.CreateCheckboxform()
    this.Getcharitydetails()
    var parsedUser1: any = localStorage.getItem('currentUser');
    const parsedUser = JSON.parse(parsedUser1);
    this.CurrentUserName = `${parsedUser.firstName} ${parsedUser.lastName}`;
  }
  editor1: Editor;
  isdirty: any = false;
  UserRoleAccess: RolesModel;
  AccountingPeriod: any;
  GetUserAccess() {
    
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.sharedService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
      })
    });
  }

  ngOnInit() {
    //this.sharedService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //})
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    this.sharedService.FY_Year$.subscribe(value => {
      let date = value.split('*')[0];
      this.AccountingPeriod = value.split('*')[1];
      this.datashare.isdirty$.subscribe(value => {
        this.isdirty = value
      })
      this.editor1 = new Editor();
      this.createStatement_of_AssetsTemplate()
    });
    this.getdata()
  }
  RetriveEmailConfigdata: any;
 
  backToCharityOverView() {
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);
  }

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  Getbasicinformation() {
    debugger

    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
      this.ispreview = data[0].istrialbalanceaSaved == 1 ? true : false
      this.ExportasPDFandIXBRL('ExportasPDF', 'ForPDFviwer', 'Attachment')

     
    })
  }
  Statement_of_Assetsform: FormGroup
  createStatement_of_AssetsTemplate() {
    this.Statement_of_Assetsform = this.fb.group({
      emailTemplateId: [0],
      emailType: ['Statement_of_Assets'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      //cc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //bcc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //pattern to allow multiple emails.
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: [''],
      charityName: [''],
      charityID: [+localStorage.getItem('charityId')!],
      financialPeriodsID: [+localStorage.getItem('currentPeriod')!],
      createdby: [0],
      modifiedby: [0],
      centralUserId: [+localStorage.getItem('CentralUserId')!],
      userId: [+localStorage.getItem('CurrentuserID')!],
      attachement:'',
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCStatement_of_Assetsform = false
    this.Statement_of_Assetsform.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.Statement_of_Assetsform.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });

  }

  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
    //this.dialog.open(emailtemplate, {
    //  width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: false
    //});
  }
  cenceltemplate() {
    debugger
    if (this.Statement_of_Assetsform.dirty) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.datashare.setisdirty(false)
          this.isdirty = false
          this.Statement_of_Assetsform.markAsUntouched()
          this.Statement_of_Assetsform.markAsPristine()
          this.Statement_of_Assetsform.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return
        }

      })

    }
    else {
      this.Statement_of_Assetsform.markAsUntouched()
      this.Statement_of_Assetsform.markAsPristine()
      this.Statement_of_Assetsform.controls['to'].markAsUntouched()
      this.dialog.closeAll()

    }

  }

  sendmail() {
    debugger
    if (this.Statement_of_Assetsform.valid) {
      this.Statement_of_Assetsform.controls['attachement'].setValue(this.base64String)
      this.apiservicemail.sentmail(this.Statement_of_Assetsform.getRawValue()).subscribe((Data: any) => {
        debugger
        var reponse = Data;
        if (reponse == "TrialBalanceEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "TrialBalanceTemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Ok",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {


      this.Statement_of_Assetsform.markAllAsTouched()
    }
  }


  RetriveEmailConfig(emailtemplate?: any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.Statement_of_Assetsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.Statement_of_Assetsform.controls['to'].markAsUntouched()
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetEmailTemplate()
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  ifCCorBCCStatement_of_Assetsform: boolean = false;

  Statement_of_AssetsformmailtoCC() {
    debugger
    this.ifCCorBCCStatement_of_Assetsform = !this.ifCCorBCCStatement_of_Assetsform;
    if (!this.ifCCorBCCStatement_of_Assetsform) {
      this.Statement_of_Assetsform.controls['cc'].reset();
      this.Statement_of_Assetsform.controls['bcc'].reset();
    }
  }
  GetEmailTemplate() {
    debugger;
    this.Charities_Service.GetEmailTemplate(this.Statement_of_Assetsform.controls['centralUserId'].value, this.Statement_of_Assetsform.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          data.entity[0].body = data.entity[0].body.replace('[UserName]', this.CurrentUserName)

          data.entity[0].subject = data.entity[0].subject.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].charityName =  localStorage.getItem('charity_Name')
          data.entity[0].subject = data.entity[0].subject.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          data.entity[0].body = data.entity[0].body.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].body = data.entity[0].body.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          this.Statement_of_Assetsform.patchValue(data.entity[0])
          this.Statement_of_Assetsform.controls['Body'].setValue(data.entity[0].body)
          this.Statement_of_Assetsform.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.Statement_of_Assetsform.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.Statement_of_Assetsform.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
          this.ifCCorBCCStatement_of_Assetsform = data.entity[0].ccCheckbox;
        }
        else {
          this.createStatement_of_AssetsTemplate()
        }
        this.Statement_of_Assetsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
        this.Statement_of_Assetsform.markAsPristine()
      },
      error: (err) => {
        console.error('Error fetching GetEmailTemplate details:', err);
      }
    });
  }  cashFunds: any[] = []
  investmentAssets: any[] = []
  otherMonetaryAssets: any[] = []
  displayedColumns: string[] = ['details', 'unrestricted', 'restricted', 'endowment'];
  retainedAssets: any[] = []
  //  { details: 'Heritage assets - 1', fundsBelongsTo: 'Endowment Funds', cost: 103.0, currentValue: 105.0 },
  //  { details: 'Heritage assets - 2', fundsBelongsTo: 'Endowment Funds', cost: 103.0, currentValue: 105.0 },
  //  { details: 'Other Land & Buildings', fundsBelongsTo: 'Restricted Funds', cost: -103.0, currentValue: 105.0 },
  //  { details: 'Computer Equipment', fundsBelongsTo: 'Restricted Funds', cost: -103.0, currentValue: 105.0 },
  //];

  liabilities: any[] = []
  //  { details: ' Wages and salaries payable', fundsBelongsTo: 'Endowment Funds', cost: 103.0, currentValue: 105.0 },
  //  { details: ' Payments received on account for contracts or performance- related grants', fundsBelongsTo: 'Endowment Funds', cost: 103.0, currentValue: 105.0 },
  //  { details: ' Obligations under HP/ Finance leases', fundsBelongsTo: 'Restricted Funds', cost: -103.0, currentValue: 105.0 },
  //  { details: 'Other creditors', fundsBelongsTo: 'Restricted Funds', cost: -103.0, currentValue: 105.0 },
  //];

  disableNaviagtion() {
    document.body.classList.add('disable')
  }
  enableNavigation() {
    document.body.classList.remove('disable')
  }

  getdata() {
    var CurrentAccpId = localStorage.getItem('currentPeriod')
    this.disableNaviagtion();
    this.ShowSpinner=true
    this.apiservice.GetStatementofAssetsAndLiabilities(CurrentAccpId).subscribe((data: any) => {
      debugger
      this.cashFunds = data?.cashFunds
      this.otherMonetaryAssets = data?.otherMonetaryAssets
      this.investmentAssets = data?.investmentAssets
      this.retainedAssets = data?.retainedAssets
      this.liabilities = data?.liabilities
      this.ShowSpinner = false
      this.enableNavigation();
      //this.ispreview = this.cashFunds[0].ispreview == 'false';
    })
  }

  ispreview: boolean=false






  firstDisplayedColumns: string[] = ['item', 'Unrestrictedfunds', 'Restricted income funds (£)', 'Endowment funds (£)', 'Total This Year (£)', 'Total Last Year (£)'];
  secondDisplayedColumns: string[] = ['item2', 'Fund to which asset belongs', 'Cost (optional) (£)', 'Current value (optional) (£)', 'Total This Year2 (£)', 'Total Last Year2 (£)'];
 
  transactions: any[] = [
    { type: 'header', text: 'B1 Cash Funds' },
    { item: 'Tangible assets', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Investments', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Total fixed assets', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },

    { type: 'header', text: 'Current assets' },
    { item: 'Stocks', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Debtors', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Cash at bank and in hand', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Total current assets', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },
    { item: 'Creditors: amounts falling due within one year', details: 'B06', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
   
    { item: 'Net current assets/(liabilities)', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },
    { item: 'Total assets less current liabilities', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },
    { item: 'Creditors: amounts falling due after one year', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Total net assets or liabilities', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },
    { type: 'second-header' },
    { type: 'header', text: 'Funds of the Charity' },
    { item: 'Endowment funds', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Restricted income funds', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Unrestricted funds', Unrestrictedfunds: 45000.00, restrictedfunds: 15000.00, end: 0.00, total: 15000.00, pyf: 15000.00, type: 'data' },
    { item: 'Total funds', Unrestrictedfunds: 90000.00, restrictedfunds: 300000, end: 0.00, total: 300000, pyf: 300000, type: 'footer' },
  ];
  transactions2: any[] = [
    { item: '', funds: 10, Costfunds: 20, end: 30, currentvalue: '£ 100.00', pyf: 45, type: 'data' },
    { item: '', funds: 10, Costfunds: 20, end: 30, currentvalue: '£0.00', pyf: 45, type: 'data' },
    { item: '', funds: 10, Costfunds: 20, end: 30, currentvalue: '£0.00', pyf: 45, type: 'data' },
  ];


  combinedDataSource: any = [
    // First table data (transactions)
    ...this.transactions.map(item => ({
      ...item,
      tableType: 'first' as const
    })),

    // Visual divider between tables
    {
      tableType: 'divider' as const,
      text: '' // Optional text if needed
    },

    // Section title
    {
      tableType: 'sectionHeader' as const,
      text: 'Asset Details'
    },

    // Second table data (transactions2)
    ...this.transactions2.map(item => ({
      ...item,
      tableType: 'second' as const
    }))
  ];


  isFirstTableDataRow = (index: number, row: any) => row.tableType === 'first' && row.type === 'data';
  isSecondTableDataRow = (index: number, row: any) => row.tableType === 'second' && row.type === 'data';
  isDividerRow = (index: number, row: any) => row.tableType === 'divider';
  isSectionHeaderRow = (index: number, row: any) => row.tableType === 'sectionHeader';
  isHeaderRow = (index: number, row: any) => row.type === 'header';
  isFooterRow = (index: number, row: any) => row.type === 'footer';
  isSubHeaderRow = (index: number, row: any) => row.type === 'subHeader';
  isFundsHeaderRow = (index: number, row: any) => row.type === 'second-header';


  Getcharitydetails() {
    debugger
    let charityID = localStorage.getItem("CharityIdforSubmission")
    if (charityID) {
      this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
        debugger
        this.CharityDetails = data
        this.Getbasicinformation()
      })
    }
  }
  Savenext() {
    debugger
    this.router.navigate(['Accountnotes']);
  }
  CreateCheckboxform() {
    this.exportForm = new FormGroup({
      coverPage: new FormControl(false),
      contentsPage: new FormControl(false),
      referenceandAdministrationDetails: new FormControl(false),
      trusteesAnnualReport: new FormControl(false),
      statementofTrusteesResponsibility: new FormControl(false),
      independentExaminersReport: new FormControl(false),
      auditorsReport: new FormControl(false),
      statementOfFinancialActivities: new FormControl(false),
      balanceSheet: new FormControl(false),
      notes: new FormControl(false),
      receiptsandPayments: new FormControl(false),
      statementofAssetsandLiabilities: new FormControl(true),
      is_ForSubmissions: new FormControl(false),  //important thing this will depend on submissions
      export_Type: new FormControl(null),
      isforPreivew: new FormControl(true)
    });
  }
  ExportasPDFandIXBRL(ExportType?: any, Is_PDFviwer?: any, template?: any) {
    debugger
    this.disableNaviagtion();
    this.ShowSpinner = true;
    this.Downloadreportname = "Statement of Assets and Liabilities Report";
   
    var Period = this.BasicInformation[0].current_AP_End_Date.slice(0, 10).split('-')
    var FileName = this.Downloadreportname
    if (Is_PDFviwer === 'ForPDFviwer' || ExportType == 'ExportasIXBRL') {
    
    }

    this.exportForm.controls["is_ForSubmissions"].setValue(false);
    this.exportForm.controls["export_Type"].setValue(ExportType);
    let Selectedcheckboxes = this.exportForm.value
    const formData: FormData = new FormData();
    // Append checkbox selections as JSON string
    formData.append('SelectedData', JSON.stringify(Selectedcheckboxes));
    formData.append('CompanyRegistrationNumber', this.CharityDetails[0].charity_Registration_Number);
    formData.append('CompanyName', this.CharityDetails[0].charity_Name);
    formData.append('APPeriodCoveredTo', '01/07/2024'); // date as string
    formData.append('ContactName', this.CharityDetails[0].first_Name_Detail);
    formData.append('ContactNumber', this.CharityDetails[0].telephone_Number);
    formData.append('CharityReferenceNumber', this.CharityDetails[0].company_Reference_Number);

    formData.append('APPeriodId', localStorage.getItem('currentPeriod') || '');
    formData.append('CompanyID', this.CharityDetails[0].charityID);

    const userId = parseInt(localStorage.getItem('userID') || '0', 10);
    formData.append('UserID', userId.toString());

    // Optional fields - pass empty string to avoid null binding issues
    formData.append('Actiontype', '');
    formData.append('AccountTemplateId', '123456'); // optional int
    formData.append('PackageReference', '');
    formData.append('submissionDate', '');
    formData.append('DateSigned', '');

    // Optional fields not in original post, but required by model
    formData.append('version', '');
    formData.append('submissionstatus', '');
    formData.append('TransactionID', '');
    formData.append('Flag', '');
    formData.append('FBI_URLToUpload', '');
    formData.append('FBI_XMLToUpload', '');
    formData.append('FBIStatus', '');
    formData.append('SaveCredentials', '');
    formData.append('FBI_Master_ID', '');
    formData.append('FBI_History_ID', '');
    formData.append('RequestType', '');
    formData.append('URL', '');
    formData.append('ResponseType', '');
    formData.append('ResponseTimeStamp', '');
    formData.append('ResponseText', '');
    formData.append('PeriodEnd', '');
    formData.append('FBI_History_JSON', '');
    formData.append('FBI_History_JSON_ResponseText', '');
    formData.append('CreatedBy', '');
    formData.append('TaxYear', '');
    formData.append('FBIResponce', '');
    formData.append('APPeriodCoveredFrom', '');
    formData.append('CreatedDate', '');
    this.Submissionsapiservice.GetSelectedReports(formData).subscribe(async (data) => {

      debugger
      if (data) {
        debugger
        this.ShowSpinner = false;
        this.enableNavigation();
        var parsedData = JSON.parse(data)
        var Base64 = parsedData["base64string"]
        this.Base64orHTML = Base64.xmldata
     
        if (Is_PDFviwer == 'ForPDFviwer') {
          if (template != 'Attachment') {
            var htmlFile = 'data:application/pdf;base64,' + this.Base64orHTML
            this.Submissionsapiservice.downloadFile(htmlFile).subscribe(
              (res: any) => {
                setTimeout(() => {
                  if (this.pdfViewerAutoLoad) {
                    this.pdfViewerAutoLoad.pdfSrc = res;
                    this.pdfViewerAutoLoad.downloadFileName = FileName;
                    this.pdfViewerAutoLoad.refresh();
                  }
                }, 1000); //1000 milli seconds(1 sec)

              })
            this.dialog.open(template, { width: '60%', maxWidth: '100%', height: '90%', disableClose: true }); //For opening PDFviewer

          } else {
            let base64String = this.Base64orHTML;
            if (base64String.startsWith("data:application/pdf;base64,")) {
              base64String = base64String.replace("data:application/pdf;base64,", "");

            }
            this.base64String = base64String.replace(/^"|"$/g, "");
          }
        
        } else {
          if (ExportType == 'ExportasPDF') {
            // Convert base64 string to byte array
            const byteCharacters = atob(this.Base64orHTML);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${FileName}.pdf`;
            link.click();
            // Optional: clean up
            window.URL.revokeObjectURL(link.href);
            // this.closeModalPreview() 
          }
          else {
            var blob = new Blob([this.Base64orHTML], { type: "text/html" });
            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${FileName}.html`;
            link.click();
            // this.closeModalPreview()
          }
        }
       
      }
    })
  }

  Preview(template: any) {
    debugger
    this.ShowSpinner = true

    this.reportservice.Statement_of_Assets_liabilities_Reports(+localStorage.getItem('currentPeriod')!, localStorage.getItem('IsFirstAccountingPeriod'), localStorage.getItem('fund_Tracking') == 'true' ? true : false).subscribe((data: any) => {
      debugger
      console.log(data)
     const byteCharacters = atob(data.Item1.toString());
     // const byteCharacters = atob(data.PdfBytes);   // 👈 use PdfBytes
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfFile = URL.createObjectURL(blob);

      this.Downloadreportname = "Statement of Assets and Liabilities Report.pdf";
      this.dialog.open(template, {
        width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
      });
      setTimeout(() => {
        if (this.pdfViewerAutoLoad) {
          this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
          this.pdfViewerAutoLoad.downloadFileName = this.Downloadreportname;
          this.pdfViewerAutoLoad.page = 1;
          this.pdfViewerAutoLoad.refresh();
          this.ShowSpinner = false
        }
      }, 1000)
      // this.ShowSpinner = false
    })
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            localStorage.setItem('NewAmendCycle', 'true');
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

}
